module.exports = __webpack_public_path__ + "img/nbe_phonecash.d294027e.png";